export const copilot = {
variant: {
recommendation: "Recommandation",
action: "Action prête",
insight: "Analyse",
},
dismiss: {
accessibilityLabel: "Ignorer la suggestion",
},
rationale: {
label: "Pourquoi",
skillLabel: "Pourquoi cette compétence",
riskLabel: "Pourquoi ce niveau de risque",
notProvided: "Justification non fournie par le modèle.",
},
followUp: {
kicker: "L'IA rédige…",
loadingCaption: "Sélection de la compétence, du risque et de l'urgence à partir des notes de cet élément.",
successKicker: "Suggestion de l'IA prête",
idleBodyWithAsset: "L'IA peut rédiger une intervention de suivi pour cet élément sur {{assetName}} — en choisissant la compétence, le risque et l'urgence adaptés avant votre validation.",
idleBodyNoAsset: "L'IA peut rédiger une intervention de suivi pour cet élément — en choisissant la compétence, le risque et l'urgence adaptés avant votre validation.",
suggestCta_one: "Suggérer avec l'IA · {{count}} crédit",
suggestCta_many: "Suggérer avec l'IA · {{count}} crédits",
suggestCta_other: "Suggérer avec l'IA · {{count}} crédits",
createCta: "Créer le suivi",
whyExpand: "Pourquoi ?",
whyCollapse: "Masquer le pourquoi",
discard: "Ignorer",
errorFallback: "L'IA n'a pas pu analyser cet élément.",
fallbackCta: "Créer un brouillon manuellement",
skillNotMatched: "Compétence non trouvée",
skillNotInCatalogWarning: "L'IA a proposé une compétence absente de votre catalogue. Choisissez-en une manuellement à l'écran suivant.",
},
riskLabel: {
low: "Risque faible",
medium: "Risque moyen",
high: "Risque élevé",
critical: "Risque critique",
},
urgencyLabel: {
standard: "Standard",
priority: "Prioritaire",
urgent: "Urgent",
},
confidence: {
high: "Confiance élevée",
medium: "Confiance moyenne",
low: "À vérifier avant validation",
},
dock: {
openAssistant: "Ouvrir l'assistant",
expandAssistant: "Développer l'assistant",
assistantTitle: "Assistant",
closeAssistant: "Fermer l'assistant",
loadingConversation: "Chargement de la conversation...",
assistantEmptyTitle: "Demandez à l’assistant",
assistantEmptyBody: "Utilisez le même assistant opérationnel depuis l'intérieur de ce panneau latéral.",
actorYou: "Vous",
actorAssistant: "Assistant",
dictationInserting: "Insertion du texte…",
dictationFinishing: "Fin de la dictée…",
dictationHeard: "Entendu : {{transcript}}",
dictationListening: "Écoute…",
messageInputLabel: "Envoyer un message à l'assistant",
messagePlaceholder: "Posez une question ou dites à l'assistant quoi faire",
stopDictation: "Arrêter la dictée",
dictateMessage: "Dicter un message",
startNewThread: "Démarrer un nouveau fil de discussion assistant",
newThread: "Nouveau fil",
sendAssistantMessage: "Envoyer un message à l'assistant",
sending: "Envoi...",
send: "Envoyer",
noSuggestionsWithAsk: "Aucune suggestion pour le moment. Posez votre question à l’assistant ci-dessous.",
noSuggestions: "Aucune suggestion pour le moment.",
openAssistantInput: "Ouvrir la saisie de l'assistant",
askPlaceholder: "Demandez à l’assistant…",
dictateAssistantMessage: "Dicter un message pour l'assistant",
},
photoFixSuggestion: {
idleHeaderText: "Utilisez la photo pour rédiger un correctif",
idleHint: "L'IA examine la photo et les notes de l'inspecteur pour suggérer un titre, une portée, une priorité et un coût approximatif.",
suggestA11y_one: "Suggérer un correctif à partir de la photo. Coûte {{count}} crédit.",
suggestA11y_other: "Suggérer un correctif à partir de la photo. Coûte {{count}} crédits.",
suggestButton_one: "Suggérer un correctif à partir de la photo ({{count}} crédit)",
suggestButton_other: "Suggérer un correctif à partir de la photo ({{count}} crédits)",
loadingStage1: "Lecture de la photo…",
loadingStage2: "Repérage du défaut probable…",
loadingStage3: "Rédaction du correctif…",
loadingStage4: "J’y suis presque…",
loadingHint: "Regarder la photo prend quelques secondes : vous pouvez continuer à travailler.",
retryA11y: "Réessayer la suggestion de correctif",
tryAgain: "Réessayer",
headerEyebrow: "Recommandation de correction IA · {{pct}} % de confiance",
priorityHigh: "Élevée",
priorityMedium: "Moyenne",
priorityLow: "Faible",
priorityChip: "Priorité {{level}}",
safetyCallouts: "Alertes de sécurité",
useThisFixA11y: "Utiliser ce correctif comme brouillon d'intervention",
useThisFix: "Utilisez ce correctif",
discardA11y: "Supprimer cette suggestion",
discard: "Ignorer",
suggestA11y_many: "Suggérer un correctif à partir de la photo. Coûte {{count}} crédits.",
suggestButton_many: "Suggérer un correctif à partir de la photo ({{count}} crédits)",
},
};
